import React from "react";
import "../../Coporate-travel-management/CorporateBanner/CorporateBanner.css";
import BannerWrapper from "../../../commonComponents/BannerWrapper";

const OurStoryBanner = ({ onLoad }) => {
  return (
    <BannerWrapper onLoad={onLoad}>
      {({ useHighRes, imageLoaded, handleImageLoad }) => (
        <div
          className="container-fluid ctm-banner position-relative p-0"
          style={useHighRes && !imageLoaded ? { minHeight: 0 } : {}}
        >
          {/* High-priority, eager-loaded image */}
          <img
            src="https://blueberrywebsites.azureedge.net/BBT/New%20Banners%20all%20pages/New%20DesignBanners%20BBT/9.%20Our%20Story.webp"
            alt="Our Story Banner"
            className="w-100"
            loading={useHighRes ? "eager" : "lazy"}
            onLoad={handleImageLoad}
            fetchpriority={useHighRes ? "high" : "auto"}
          />

          {imageLoaded ? (
            <div className="ctm-text position-absolute text-white mt-xxl-4 mt-3">
              <p className="fs4 text-uppercase busy grotesk-headings">
                OUR LEGACY
              </p>
              <h1 className="banner-headings w-100">
                Discover The Journey Behind Blueberry Travels
              </h1>
              <div className="d-flex common-second-content">
                <div className="ornge-border"></div>
                <div className="second-content">
                  What sets us apart in corporate travel? With services like
                  private transfers, customized itineraries, and expert advice,
                  we ensure your business trips are smooth and efficient.
                </div>
              </div>
            </div>
          ) : null}
        </div>
      )}
    </BannerWrapper>
  );
};

export default OurStoryBanner;
